// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"about_aboutContainer__3pRer","contentContainer":"about_contentContainer__1AMm3","content":"about_content__1OCEo"};